import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

const startAllocation = async () => {
  const token = getToken();
  let valid = false;

  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/sustainability_reports/allocate_storages`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      var result = await response.json();
      valid =
        result &&
        result.success &&
        result.delivered_quantities &&
        result.biotemplates &&
        result.sustainability_quantities;
    } catch (except) {
      valid = false;
    }
  }

  if (!valid) {
    if (result && result.errors)
      return {
        valid: false,
        message: result.errors,
      };
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
    delivered_quantities: result.delivered_quantities,
    biotemplates: result.biotemplates,
    sustainability_quantities: result.sustainability_quantities,
  };
};

export default startAllocation;
